import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import store from '@/store'
import Test from '@/views/Test.vue'
import Health from '@/views/Health.vue'
import Top from '@/views/Top.vue'
import Profile from '@/views/Profile.vue'
import Login from '@/views/Login.vue'
import Signup from '@/views/Signup.vue'
import VerifyEmail from '@/views/VerifyEmail.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import Logout from '@/views/Logout.vue'
import RegisterCard from '@/views/RegisterCard.vue'
import ViewCards from '@/views/ViewCards.vue'
import EditCard from '@/views/EditCard.vue'
import SearchCard from '@/views/SearchCard.vue'
import RegisterEntry from '@/views/RegisterEntry.vue'
import SearchEtries from '@/views/SearchEtries.vue'
import ViewEntries from '@/views/ViewEntries.vue'
import EditEntry from '@/views/EditEntry.vue'
import Stocks from '@/views/Stocks.vue'
import SelectEntry from '@/views/SelectEntry.vue'
import RegisterExit from '@/views/RegisterExit.vue'
import SearchExits from '@/views/SearchExits.vue'
import ViewExits from '@/views/ViewExits.vue'
import EditExit from '@/views/EditExit.vue'
import ChoicePurchaseItems from '@/views/ChoicePurchaseItems.vue'
import InputPurchasePrice from '@/views/InputPurchasePrice.vue'
import MakePurchasePdf from '@/views/MakePurchasePdf.vue'
import MainViewStores from '@/views/MainViewStores.vue'
import MainStoreDetail from '@/views/MainStoreDetail.vue'
import MainSearchEtries from '@/views/MainSearchEtries.vue'
import MainSearchExits from '@/views/MainSearchExits.vue'
import { getAuth, onAuthStateChanged } from "firebase/auth";


Vue.use(VueRouter)

const routes = [
  {
    path: '/test',
    name: 'Test',
    component: Test,
    meta: { pageType: 'noRequireAuth' }
  },
  {
    path: '/health',
    name: 'Health',
    component: Health,
    meta: { pageType: 'noRequireAuth' }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: { pageType: 'noRequireAuth' }
  },
  {
    path: '/verify_email',
    name: 'VerifyEmail',
    component: VerifyEmail,
    meta: { pageType: 'noRequireAuth' }
  },
  {
    path: '/reset_password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { pageType: 'noRequireAuth' }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { pageType: 'noRequireAuth' }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: { pageType: 'noRequireAuth' }
  },
  {
    path: '/',
    name: 'Top',
    component: Top,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/register-card',
    name: 'RegisterCard',
    component: RegisterCard,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/view-cards',
    name: 'ViewCards',
    component: ViewCards,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/edit-card/:card_id',
    name: 'EditCard',
    component: EditCard,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/search-card',
    name: 'SearchCard',
    component: SearchCard,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/register-entry/:card_id',
    name: 'RegisterEntry',
    component: RegisterEntry,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/search-entries',
    name: 'SearchEtries',
    component: SearchEtries,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/view-entries',
    name: 'ViewEntries',
    component: ViewEntries,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/edit-entry/:entry_id',
    name: 'EditEntry',
    component: EditEntry,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/stocks',
    name: 'Stocks',
    component: Stocks,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/select-entry/',
    name: 'SelectEntry',
    component: SelectEntry,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/register-exit/:card_id',
    name: 'RegisterExit',
    component: RegisterExit,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/search-exits',
    name: 'SearchExits',
    component: SearchExits,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/view-exits',
    name: 'ViewExits',
    component: ViewExits,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/edit-exit/:exit_id',
    name: 'EditExit',
    component: EditExit,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/choice-purchase-items',
    name: 'ChoicePurchaseItems',
    component: ChoicePurchaseItems,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/input-purchase-price',
    name: 'InputPurchasePrice',
    component: InputPurchasePrice,
    meta: { pageType : 'requireAuth' }
  },
  {
    path: '/make-purchase-pdf',
    name: 'MakePurchasePdf',
    component: MakePurchasePdf,
    meta: { pageType: 'noRequireAuth' }
  },
  {
    path: '/main-view-stores',
    name: 'MainViewStores',
    component: MainViewStores,
    meta: { pageType : 'onlyMain' }
  },
  {
    path: '/main-store-detail/:store_id',
    name: 'MainStoreDetail',
    component: MainStoreDetail,
    meta: { pageType : 'onlyMain' }
  },
  {
    path: '/main-search-entries',
    name: 'MainSearchEtries',
    component: MainSearchEtries,
    meta: { pageType : 'onlyMain' }
  },
  {
    path: '/main-search-exits',
    name: 'MainSearchExits',
    component: MainSearchExits,
    meta: { pageType : 'onlyMain' }
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        top: 0
      }
    }
  },
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.pageType == 'requireAuth')) {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        next()
      } else {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }
    })
  } else if (to.matched.some(record => record.meta.pageType == 'onlyMain')) {
    const fetchData = async () => {
      var check_main = false
      await axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/account/check_main`, {
          params: { email: store.getters.getEmail }
        })
        .then(res => {
          check_main = res.data.is_main
        })
        .catch(() => {
          alert(e)
        })
      const auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        if (user && check_main) {
          next()
        } else {
          next({
            path: '/',
          })
        }
      })
    }
    fetchData()
  } else if (to.matched.some(record => record.meta.pageType == 'noRequireAuth')) {
    next()
  }
})


export default router
